import React, { useRef, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom'; // Import useLocation
import { Routes as RouteConfig } from '../router/routes'; // Import Routes array
import SearchComponent from './search/SearchComponent';
import LanguageDropDown from './languageSelector/LanguageDropComp';
import { useSelector } from "react-redux";
import { GetBrandingData } from 'gigi-api-layer/src';
import extractDomain from 'extract-domain';
import { setBookingAgency, setBookingAgent } from '../redux/actions/language';
import { useDispatch } from "react-redux";

import AmazonConnectChat from '../components/chatwidget/Chatinit';
const App = () => {
  const location = useLocation(); // Get the current location
  const navigate = useNavigate();
  const pathName = location.pathname;
  const scriptInjected = useRef(false);
  const language = useSelector((state: any) => state.languageChange.language);
  const [getBranding, brandingData, brandingLoader, brandingError] = GetBrandingData();
  const isHeader = document.getElementById("B2CHeader");
  const isFooter = document.getElementById("B2CFooter");
  const dispatch = useDispatch();

  const [version,setVersion] = useState(0);

  async function addRemoveHeaderFooter(headerURL, footerURL) {
    try {
      await loadHeaderScript(headerURL);
      console.log("Header script loaded successfully");
    } catch (error) {
      console.error(error.message);
    }
    loadFooterContent(footerURL);


    async function loadHeaderScript(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to load header content: ${response.statusText}`);
        const headerHTML = await response.text();
        document.body.insertAdjacentHTML("beforebegin", `<div id="B2CHeader">${headerHTML}</div>`);

        const initializeMobileMenu = () => {
          const toggle = document.getElementById('menu-toggle');
          const mobileNav = document.getElementById('mobile-nav');
          
          if (toggle && mobileNav) {
            toggle.addEventListener('click', () => {
              mobileNav.classList.toggle('active');
              toggle.classList.toggle('close');
            });
          }
        };

        // Small delay to ensure DOM is updated
        setTimeout(initializeMobileMenu, 100);
      } catch (error) {
        console.error(error.message);
      }
    }

    async function loadFooterContent(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to load footer content: ${response.statusText}`);
        const footerHTML = await response.text();
        document.body.insertAdjacentHTML("beforeend", `<div id="B2CFooter">${footerHTML}<style>#B2CFooter .footer-secondary .container{display:block;}</style></div>`);
      } catch (error) {
        console.error(error.message);
      }
    }
  }

  React.useEffect(() => {
    const path = location.pathname;
    const searchParams = location.search;  // Get query parameters

    if (path !== '/' && path.endsWith('/')) {
      // Normalize URL by removing trailing slash
      const normalizedPath = path.slice(0, -1); // Remove the trailing slash
      navigate(normalizedPath + searchParams, { replace: true }); // Replace the URL without reloading
    }
  }, [location, navigate]);

  React.useEffect(() => {
    let url = extractDomain(window.location.hostname);
    getBranding({ site: url })
  }, [])

  React.useEffect(() => {
    if (brandingData?.length) {
      const getScript = (GTMID = process.env.DEFAULT_GTM_ID) => {
      if (!GTMID || document.getElementById('gtm-script')) return;

      // GTM Script for <head>
      const gTaghead = document.createElement('script');
      gTaghead.id = 'gtm-script';
      gTaghead.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTMID}');`;
      document.head.appendChild(gTaghead);

      // GTM noscript for start of <body>
      if (!document.getElementById('gtm-noscript')) {
        const gBodyTag = document.createElement('noscript');
        gBodyTag.id = 'gtm-noscript';

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTMID}`;
        iframe.height = "0";
        iframe.width = "0";
        iframe.style.display = "none";
        iframe.style.visibility = "hidden";

        gBodyTag.appendChild(iframe);
        document.body.insertBefore(gBodyTag, document.body.firstChild);
      }
    };
      let [branding] = brandingData;
      document.documentElement.style.setProperty('--main-primary-branding', branding.main_branding_color);
      document.documentElement.style.setProperty('--main-secondary-color', branding.main_branding_color_secondary);
      document.documentElement.style.setProperty('--main-primary-Color', branding.button_color);
      document.documentElement.style.setProperty('--main-primary-Button', branding.button_color);
      document.documentElement.style.setProperty('--Button-Text-Color', branding.button_text_color);
      document.documentElement.style.setProperty('--anchor-links', branding.anchor_links);
      document.documentElement.style.setProperty('--SearchBackground', branding.search_background);
      document.title = branding.site;
      (window as any).brandingSiteName = branding.site;
      (window as any).siteConfiguration = branding.configuration;
      (window as any).terms_url = branding.terms_url;
      (window as any).phone_number = branding?.phone_number;
      (window as any).agencycode = branding?.agencycode;
      if (!scriptInjected.current && branding.gtm_id) {
        getScript(branding.gtm_id);
        scriptInjected.current = true;
      }
      // const headerURL =
      // brandingData[0]?.agencycode === 'C0012'
      // ? (language === 'fr' ? process.env.HIS_FRENCH_HEADER : process.env.HIS_HEADER)
      // : brandingData?.headerURL ||
      //   (language === 'fr' ? process.env.DEFAULT_FRENCH_HEADER : process.env.DEFAULT_HEADER);
      
      const headerURL = 
      language === 'fr'
      ? brandingData[0]?.header_url_fr
      : brandingData[0]?.header_url_en;
      
      const footerURL =
    language === 'fr'
      ? brandingData[0]?.footer_url_fr
      : brandingData[0]?.footer_url_en;

      // const footerURL =
      //   brandingData[0]?.agencycode === 'C0012'
      //     ? (language === 'fr' ? process.env.HIS_FRENCH_FOOTER : process.env.HIS_FOOTER)
      //     : brandingData?.footerURL ||
      //       (language === 'fr' ? process.env.DEFAULT_FRENCH_FOOTER : process.env.DEFAULT_FOOTER);

      const existingHeader = document.querySelector('#B2CHeader');
      const existingFooter = document.querySelector('#B2CFooter');
      if (existingHeader) existingHeader.remove();
      if (existingFooter) existingFooter.remove();

      addRemoveHeaderFooter(headerURL, footerURL);

      if (brandingData?.[0]?.agencycode) {
        dispatch(setBookingAgency(brandingData[0].agencycode));
      }
      if (brandingData?.[0]?.agentname) {
        dispatch(setBookingAgent(brandingData[0].agentname));
      }
      setVersion((prevVersion) => prevVersion + 1);
    }
  }, [brandingData, language]);

  React.useEffect(() => {
      setVersion((prevVersion) => prevVersion + 1);
  }, [language]);
  
 //Favicon  
React.useEffect(() => {
 if (Array.isArray(brandingData) && brandingData.length > 0) {
  const site = brandingData[0].site || '';
  let sitename = site.split('.')[0];  

  if (sitename) {
    const setFaviconsFromBranding = (faviconBaseUrl: string) => {
      const links = [
        { rel: "icon", type: "image/png", href: `${faviconBaseUrl}${sitename}/favicon-96x96.png` },
        { rel: "icon", type: "image/svg+xml", href: `${faviconBaseUrl}${sitename}/favicon.svg` },
        { rel: "shortcut icon", href: `${faviconBaseUrl}${sitename}/favicon.ico` },
        { rel: "apple-touch-icon", href: `${faviconBaseUrl}${sitename}/apple-touch-icon.png` },
        { rel: "manifest", href: `${faviconBaseUrl}/site.webmanifest` },
      ];
      links.forEach(linkData => {
        const link = document.createElement("link");
        Object.entries(linkData).forEach(([key, value]) => {
          link.setAttribute(key, value as string);
        });
        document.head.appendChild(link);
      });
    };

    setFaviconsFromBranding(process.env.FAVICON_URL);
  }
}
}, [brandingData]);


  return (
    <>
      {Array.isArray(brandingData) && brandingData.length > 0 && brandingData[0].configuration.isMultiLangAllowed && (
        <LanguageDropDown />
      )}
      {language && Array.isArray(brandingData) && brandingData.length > 0 && brandingData[0].configuration.isChatWidgetAllowed && (
        <AmazonConnectChat language={language} key={version} brand={brandingData[0].site} />
      )}
      {(pathName !== "/booking" && pathName !== "/bookingConfirmation") && <SearchComponent />}
      <Routes>
        {RouteConfig.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Routes>
    </>
  );
};

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
